/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
  datasetImportId: ZodTypes.Id,
});

export const DatasetImportEditablePost = {
  id: 'dataset-import-editable.post',
  tag: 'Inventory',
  summary: 'Editable Dataset',
  description: 'Editable dataset',
  method: 'post',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/dataset-import/${params.datasetImportId}/editable`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
